<template>
  <div>
      <public-head title="新闻早班车"></public-head>
<div class="logo" v-for="(item,index) in info.thumb" :key="index">
    <img :src="item" class="_img"/>
</div>
<div class="_title">教育新闻</div>
<div class="zbc_title">{{info.zbc_title}}</div>
<div class="_content">
     <p v-html="info.zbc_content"></p>
</div>

<div class="_title">热点资讯</div>
<div class="_content">
    <p v-html="info.content"></p>
</div>

<div class="_message">
    <div>每日一语:</div>
    <div>{{info.zbc_mryy}}</div>
</div>
  </div>
</template>

<script>
    import PublicHead from "../../components/publicHead";
  import { httpPost } from "../../axios/index";
export default {
    data() {
        return {
             info:{}
        };
    },
    created() {},
    methods: {
        // 获取新闻早班车数据
        fetchOcupptation(name) {
            httpPost("/index/details_zbc", {
               id: this.$route.query.id,
            }).then(res => {
               
                if (res.code === 1) {
                   this.info=res.info
                }
            });
        },
        
    },
    mounted() {
        this.fetchOcupptation();
       
    },
    components: {
        PublicHead
    }
}
</script>

<style>
    .logo {
    height: 12.875rem;
    margin-top: 46px;
}

img {
    width: 100%;
    height: 100%;
}

._title {
    width: 7.1875rem;
    padding: 0.5rem 0.625rem;
    background: #00a0e2;
    color: #fff;
    border-radius: 0.3125rem;
    margin:1.5625rem auto;
    font-size: 1.125rem;
    text-align: center;
}

._content {
    color: #383838;
    font-size: 0.875rem;
    width: 88vw;
    margin: 0 auto;
    line-height: 1.5625rem;
    /* text-indent:50rpx; */
}
.zbc_content{
    color: #383838;
    font-size: 0.875rem;
    width: 88vw;
    margin: 0 auto;
    line-height: 1.5625rem;
}

.zbc_title {
    text-align: center;
    font-weight: 600;
    color: #383838;
    font-size: 1.125rem;
    margin-bottom: 1.5625rem;
}
._message{
    width: 88vw;
    margin: 3.125rem auto;
    border: 1px #383838 dashed;
    padding: 0.625rem 0.5rem;
    box-sizing: border-box;
    line-height: 1.875rem;
    color: #383838;
    font-size: 0.875rem;
}
.image-style-align-center{
    margin: 0 auto;
    text-align: center;
}
</style>